import { render, staticRenderFns } from "./Chapter2_1.vue?vue&type=template&id=4c28e117&scoped=true&"
import script from "./Chapter2_1.vue?vue&type=script&lang=js&"
export * from "./Chapter2_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28e117",
  null
  
)

export default component.exports